import { Modal } from 'components/modal/modal';

export default (function () {
    /*---------------------ADD EXTRA AJAX DATA TO CART BLOCK-------------------------*/
    const addCartAjaxData = function () {
        const showroomPickupEl = document.getElementById('showroom-pickup-information-container');

        //Show pickup information in delivery tab
        if (showroomPickupEl) {
            showroomPickupEl.addEventListener('click', (e) => {
                const showroomLink = e.target.closest('.showroom-pickup-link');
                if (showroomLink) {
                    e.preventDefault();
                    const addToCartForm = document.getElementById('addProductToCartForm');
                    if (addToCartForm) {
                        addToCartForm.submit();
                    }
                }
            });
        }
    };
    /*---------------------Create add to cart popup-------------------------*/

    const showAddedToCartPopup = () => {
        const addToCartPopup = new Modal({
            selector: '.atc-product-popup',
            isClosable: true
        });

        addToCartPopup.show();

        const continueShoppingLink = document.querySelector('.atc-product-popup .continue-shopping ');

        if (continueShoppingLink) {
            continueShoppingLink.addEventListener('click', (e) => {
                e.preventDefault();
                addToCartPopup.hide();
            });
        }
    };

    /*-----------------------------PUBLIC METHODS------------------------------*/
    return {
        addAjaxData: addCartAjaxData,
        showAddedToCartPopup: showAddedToCartPopup
    };
})();
